// Background scroll lock for open drawers/menus.
//
// Components signal a lock by toggling `overflow-hidden` on <body> (cart drawer,
// content drawer, quick view, mobile menu, collection filters, wizzy search…).
// base.css turns that class into the actual lock, which is all desktop and
// Android need: the scroll offset is kept, so sticky elements stay put.
//
// iOS Safari ignores `overflow: hidden` for touch scrolling, so there we also
// pin <body> with position: fixed and restore the offset on unlock. The pin is
// iOS-only on purpose: it zeroes window.scrollY, which unsticks `position:
// sticky` elements and makes the hide-on-scroll header reappear.
//
// Worth re-testing on a real iPhone: until the base.css lock was fixed it never
// actually applied on any platform, so iOS may honour it now and this whole file
// can go.

(function () {
  const isIOS =
    /iP(hone|od|ad)/.test(navigator.platform) ||
    // iPadOS 13+ reports itself as a Mac; touch points give it away.
    (navigator.maxTouchPoints > 1 && /Macintosh/.test(navigator.userAgent));

  if (!isIOS) return;

  let scrollY = 0;
  let locked = false;

  const lock = () => {
    if (locked) return;
    locked = true;
    scrollY = window.scrollY;
    const { style } = document.body;
    style.position = 'fixed';
    style.top = `-${scrollY}px`;
    style.left = '0';
    style.right = '0';
    style.width = '100%';
  };

  const unlock = () => {
    if (!locked) return;
    locked = false;
    const { style } = document.body;
    style.position = '';
    style.top = '';
    style.left = '';
    style.right = '';
    style.width = '';
    window.scrollTo(0, scrollY);
  };

  const sync = () => {
    if (document.body.classList.contains('overflow-hidden')) {
      lock();
    } else {
      unlock();
    }
  };

  new MutationObserver(sync).observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });
})();
